import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api.service';
import { IccOrphanExemptionDrugImport } from '../../models/icc/icc-orphan-exemption-drug-import.model';
import { IccImportFilters } from '../../models/icc/icc-import-settings.model';
import { PagedResults } from 'app/core/models/paged-results/paged-results.model';
import { LimitOffsetPagingMeta } from 'app/core/models/paged-results/limit-offset-paging.model';

export class PagedIccOrphanExemptionDrugImports implements PagedResults {
  orphanExemptionDrugImports: IccOrphanExemptionDrugImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.orphanExemptionDrugImports;
  }
}

@Injectable()
export class IccOrphanExemptionDrugImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<IccOrphanExemptionDrugImport> {
    return this.http.get<IccOrphanExemptionDrugImport>(
      `${environment.captureApi.url}/icc/orphan_exemption_drug_imports/${id}`
    );
  }

  getList(
    paging: { page: number; pageSize: number } = null,
    filters: IccImportFilters = null
  ): Observable<PagedIccOrphanExemptionDrugImports> {
    const params = new URLSearchParams();

    if (filters && filters.selectedClientIds) {
      filters.selectedClientIds.forEach(clientId => params.append('client_ids[]', clientId));
    }

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedIccOrphanExemptionDrugImports>(
      `${environment.captureApi.url}/icc/orphan_exemption_drug_imports?${params.toString()}`
    );
  }

  create(clientId: number, name: string, signedId: string): Observable<IccOrphanExemptionDrugImport> {
    return this.http.post<IccOrphanExemptionDrugImport>(
      `${environment.captureApi.url}/icc/orphan_exemption_drug_imports`,
      {
        orphanExemptionDrugImport: { clientId, name, signedId },
      }
    );
  }

  update(id, name): Observable<IccOrphanExemptionDrugImport> {
    return this.http.put<IccOrphanExemptionDrugImport>(
      `${environment.captureApi.url}/icc/orphan_exemption_drug_imports/${id}`,
      {
        orphanExemptionDrugImport: { name },
      }
    );
  }

  cancel(id): Observable<IccOrphanExemptionDrugImport> {
    return this.http.patch<IccOrphanExemptionDrugImport>(
      `${environment.captureApi.url}/icc/orphan_exemption_drug_imports/${id}/cancel`,
      {}
    );
  }
}
